<template>
  <v-layout class="full-height-container" justify-center align-center>
    <v-list class="list text-xs-left">
      <h2 class="py-3 px-4">
        View this tax return as:
      </h2>

      <v-list-tile
        v-for="identity in selectableIdentities"
        :key="identity.id"
        @click="$emit('select-identity', identity)"
        class="list__tile"
      >
        <v-list-tile-avatar>
          <v-icon large class="material-icons-outlined grey--text"
            >account_circle</v-icon
          >
        </v-list-tile-avatar>

        <v-list-tile-content class="list__tile_content">
          <v-list-tile-title v-html="identity.name"></v-list-tile-title>
          <v-list-tile-sub-title
            v-html="identity.title"
          ></v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon ripple>
            <v-icon color="grey lighten-1">chevron_right</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>

      <template v-if="identityVerificationsEnabled">
        <v-divider class="mt-3" />
        <div class="py-2 px-4 grey--text text--darken-1">
          <v-icon class="mr-1 material-icons-outlined grey--text" small
            >info</v-icon
          >
          Identity verification will be required in the next step.
        </div>
      </template>

      <template v-if="stripeIDVEnabled">
        <v-divider class="mt-3" />
        <div class="py-2 px-4 grey--text text--darken-1">
          <v-icon class="mr-1 material-icons-outlined grey--text" small
            >info</v-icon
          >
          You will be required to complete an identity verification in the next
          step. Please have your government-issued ID ready.
        </div>
      </template>
    </v-list>
  </v-layout>
</template>

<script>
export default {
  props: {
    selectableIdentities: {
      type: Array,
      default: () => [],
    },
    identityVerificationsEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.full-height-container {
  height: 100vh;
}

.list {
  width: 360px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0 0 0 / 25%);
}

.list__tile {
  padding: 6px 0px;
}
</style>
